export default "__VITE_ASSET__dbteBhx1__"